module.exports = __webpack_public_path__ + "static/img/online_pic6.605afa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online_pic6.jpg
// module id = 9L1r
// module chunks = 21